export default "__VITE_ASSET__9205ccf5__"